import { useContext, useEffect } from 'react';

import { setGAConfig } from '../utils';
import { useAppEnvironment } from './useAppEnvironment';
import { AuthContext } from '@repo-level/core-front';
import { localStorageStag } from 'modules/userTrackingParams';

/**
 * @description This hook is used to set the Google Analytics configuration.
 * It retrieves the tracking parameters from the user tracking store and the user ID from the AuthContext.
 */
export const useGAConfigHook = () => {
  const { user } = useContext(AuthContext);
  const platform = useAppEnvironment();

  useEffect(() => {
    setGAConfig({
      stag: localStorageStag.get(),
      user_id: user?.id,
      platform,
    });
  }, [user?.id, platform]);
};
